import { render, staticRenderFns } from "./Sobre.vue?vue&type=template&id=1a9406bd"
import script from "./Sobre.vue?vue&type=script&setup=true&lang=js"
export * from "./Sobre.vue?vue&type=script&setup=true&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports